import { Component, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  private translate = inject(TranslateService);

  loggingIn = false;  errorMessage = '';
  hidePassword = true;

  emailFormControl = new FormControl('', [Validators.required, Validators.email]);
  passwordFormControl = new FormControl('', [Validators.required]);

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  onSubmit() {
    this.errorMessage = '';

    if (this.emailFormControl.invalid || this.passwordFormControl.invalid) {
      return;
    }

    this.loggingIn = true;

    const email = this.emailFormControl.value ?? '';
    const password = this.passwordFormControl.value ?? '';

    this.authService.realLogin(email, password).subscribe({
      next: (resData) => {
        if (resData.status === 200 && resData.data) {
          this.router.navigate(['/panel-operativo']);
        } else {
          this.errorMessage = resData.msg || this.translate.instant('AUTH.AUTH_ERROR');
          this.loggingIn = false;
          this.passwordFormControl.reset();
        }
      },
      error: (err: unknown) => {
        this.passwordFormControl.reset();
        this.errorMessage = typeof err === 'string' ? err : this.translate.instant('AUTH.AUTH_ERROR');
        this.loggingIn = false;
      },
    });
  }
}
